import EmailCollectionStep from "@/components/Step/EmailCollectionStep";
import { Steps } from "./types";

export const emailStep: Steps = {
  emailCollection: {
    id: "emailCollection",
    slug: "epost",
    text: "Vill du veta mer om:",
    type: "custom",
    component: EmailCollectionStep,
    skippable: true,
    flowProgress: 1,
    nextStep: () => null,
  },
};
